export const prepareMedicalOrderDrafts = (drafts = []) => {
  const normalizedDrafts = drafts.map((draft) => ({
    check_type: String(draft?.check_type || '').trim(),
    description: String(draft?.description || '').trim()
  }));

  return {
    orders: normalizedDrafts.filter((draft) => draft.check_type),
    hasMissingCheckType: normalizedDrafts.some((draft) => !draft.check_type && draft.description)
  };
};
